import { Timestamp } from '@angular/fire/firestore';

/**
 * Mobile scan session for tracking scanned items in-progress
 */
export interface IStockTakeScanSession {
  itemCount: number;
  scannedItems: Record<string, { code: string; count: number }>;
  startTime: Timestamp;
  stockTakeId: string;
  userId: string;
  lastScanTime?: Timestamp;
}
